<template>
  <div class="search-box">
    <div class="left-select">
      <div class="select" @click="handleShowProperties">筛选</div>
    </div>

    <div class="center-input">
      <input v-model="searchTerm" type="text" placeholder="21,673,384 数据量"
             @keyup.enter="handleFind"/>
    </div>

    <div class="right-icons">
      <img src="@/assets/images/camera.png" alt="" class="custom-button camera-icon"/>
      <img src="@/assets/images/search2.png" alt="" class="custom-button search-icon" @click="handleFind"/>
    </div>

    <div class="drop-down-box" v-if="showProperties">
      <div class="properties" v-for="(item, index) in attributeArr" :key="index">
        <!--        <div class="property-name">{{item.name}}</div>-->
        <ul class="property-values">
          <li v-for="(item1, index1) in item.parameterDTOS" :key="index1" @click.stop="handleChange(item1.id)">
            <input
              type="checkbox"
              :key="item1.id"
              :checked="selectedArr.includes(item1.id)"
            />
            <span class="multiple-ellipsis">{{ item1.name }}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, defineEmits } from 'vue'
import { useRouter } from 'vue-router'
import { getAttribute } from '@/apis'

const router = useRouter()
const emit = defineEmits(['is-show'])

const searchTerm = ref('')

const attributeArr = ref([
  {
    id: '1',
    name: '元素',
    parameterDTOS: [
      {
        id: '3d',
        name: '3D模型'
      }
    ]
  }
])
// getAttribute().then(res => {
//   attributeArr.value = res.data
// })

function handleFind () {
  router.push({
    name: 'SearchResult',
    query: {
      searchTerm: searchTerm.value,
      parameterValues: selectedArr.value.join(',')
    }
  })
}

// drop-down-box
const selectedArr = ref([])
const showProperties = ref(false)

function handleChange (id) {
  const index = selectedArr.value.indexOf(id)
  if (index !== -1) {
    selectedArr.value.splice(index, 1)
  } else {
    selectedArr.value.push(id)
  }
}

function handleShowProperties () {
  showProperties.value = !showProperties.value
  emit('is-show', !showProperties.value)
}
</script>

<style lang="scss" scoped>
.search-box {
  width: 1320px;
  height: 72px;
  border-radius: 5px;
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid #FFFFFF;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.15), 1px 1px 2px rgba(0, 0, 0, 0.25);
  display: flex;
  position: relative;
}

.left-select {
  padding: 7px;

  .select {
    width: 198px;
    height: 56px;
    border-radius: 5px;
    background: rgba(255, 255, 255, 0.5);
    cursor: pointer;
    font-size: 24px;
    font-weight: 600;
    line-height: 56px;
    text-align: center;
    color: #3D3D3D;
    font-family: 'NotoSerifSC', system-ui;
    position: relative;

    &:after {
      display: -webkit-box;
      content: '';
      width: 10px;
      height: 12px;
      background: url("~@/assets/images/down2.png") no-repeat center;
      position: absolute;
      right: 23px;
      top: 50%;
      margin-top: -5px;
    }
  }
}

.center-input {
  padding-left: 26px;
  flex: 1;

  input {
    height: 100%;
    width: 100%;
    background: transparent;
    color: white;
    font-size: 24px;
    font-weight: 700;
  }
}

.right-icons {
  display: flex;
  align-items: center;

  .camera-icon {
    width: 37px;
    height: 37px;
    margin-right: 38px;
  }

  .search-icon {
    width: 40px;
    height: 41px;
    margin-right: 26px;
  }
}

.drop-down-box {
  position: absolute;
  z-index: 3;
  top: 87px;
  left: 0;
  right: 0;
  background: rgba(255, 255, 255, 0.5);
  border-radius: 5px;
  padding: 30px 70px;
  color: #3D3D3D;
  display: flex;
  overflow-x: auto;

  &::-webkit-scrollbar {
    display: none;
  }

  .properties {
    flex: 1;
    margin-right: 45px;

    &:last-of-type {
      margin-right: 0;
    }
  }

  .property-name {
    font-size: 36px;
    font-weight: 600;
    font-family: 'NotoSerifSC', system-ui;
    margin-bottom: 16px;
  }

  .property-values {
    height: 450px;
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    align-content: flex-start;

    li {
      display: flex;
      align-items: center;
      height: 45px;
      cursor: pointer;

      input {
        width: 16px;
        height: 16px;
        margin: 0;
      }

      span {
        font-size: 16px;
        font-weight: 500;
        padding: 0 13px 0;
        flex: 1;
        -webkit-line-clamp: 1;
      }
    }
  }
}
</style>
